import styled from 'styled-components';

import { useTranslation } from '@hooks';
import { Caption } from '@components/styles/Typography';

const Price = ({
    price,
    discountedPrice,
    discountRate,
    withoutDiscountRate,
    small,
}) => {
    const { useCurrency } = useTranslation();
    const priceFormatted = useCurrency(price);
    const discountedPricedFormatted = useCurrency(discountedPrice);
    return (
        <Container>
            {!withoutDiscountRate && discountRate ? (
                <DiscountRate>%{discountRate}</DiscountRate>
            ) : null}
            <PriceContainer>
                {price?.TRY > discountedPrice?.TRY ? (
                    <NormalPrice>{priceFormatted}</NormalPrice>
                ) : null}

                {discountRate > 0 ? (
                    <DiscountedPrice small={small}>
                        {discountedPricedFormatted}
                    </DiscountedPrice>
                ) : (
                    <Caption>{discountedPricedFormatted}</Caption>
                )}
            </PriceContainer>
        </Container>
    );
};
const Container = styled.div`
    width: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
        width: max-content;
        gap: 20px;
    }
`;
const PriceContainer = styled.div`
    display: flex;
    flex-direction: column;
`;
const DiscountRate = styled.div`
    height: 26px;
    background-color: ${({ theme }) => theme.colors.bgGray50};
    color: ${({ theme }) => theme.colors.secondary};
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 6px;
    font-size: 14px;
    line-height: 13px;
    border-radius: 3px;
`;
const NormalPrice = styled(Caption)`
    text-align: center;
    text-decoration: line-through;
    margin-bottom: 5px;
    color: ${({ theme }) => theme.colors.bgGray50};

    @media (max-width: 1024px) {
        opacity: 0.7;
    }
`;
const DiscountedPrice = styled(Caption)`
    text-align: left;
`;
export default Price;
